import React from 'react';

import kdSpinner from '../../assets/images/api/kdspinner.gif';

function KdLoading({ message = 'Loading...' }){
  return (
    <div className="c-kd-loading">
      <img className="c-kd-loading__image" alt={message} src={kdSpinner} />
      <span className="c-kd-loading__loading" > {message} </span>
    </div>
  );
}

export default KdLoading;


// WEBPACK FOOTER //
// ./app/components/KdLoading/index.js